import { useCallback, useEffect, useState } from 'react';

import { getFavorites, toggleFavorite } from '@/lib/doc/storage';

/**
 * Per-browser favorite documents. Favorites are local to the device
 * (a small localStorage record per pubkey).
 */
export function useDocFavorites(pubkey: string | undefined) {
  const [favorites, setFavorites] = useState<Set<string>>(() => new Set());

  useEffect(() => {
    setFavorites(pubkey ? getFavorites(pubkey) : new Set());
  }, [pubkey]);

  const toggle = useCallback(
    (docKey: string) => {
      if (!pubkey) return;
      toggleFavorite(pubkey, docKey);
      setFavorites(new Set(getFavorites(pubkey)));
    },
    [pubkey],
  );

  return { favorites, toggle, isFavorite: (docKey: string) => favorites.has(docKey) };
}
